// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/ui/Navbar';
import Footer from './components/ui/Footer';
import Homepage from './pages/Homepage';
import AboutUs from './pages/AboutUs';
import Board from './pages/Board';
import ContactUs from './pages/ContactUs';
// import Events from './pages/Events';
import Gallery from './pages/Gallery';
// import News from './pages/News';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex flex-col">
        <Navbar />
        <main className="flex-1 w-full">
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/board" element={<Board />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/gallery" element={<Gallery />} />
           {/**
            *  <Route path="/events" element={<Events />} />
            <Route path="/news" element={<News />} />
            */}
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;